import { createSlice } from "@reduxjs/toolkit";
import { duotoneDark } from "react-syntax-highlighter/dist/esm/styles/prism";






const initialThingChannelsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  
  thingChannelTypes:undefined,
  thingChannelTypeForEdit: undefined,
  thingChannelTypesTotalCount: 0,
  listLoadingThingChannelType: false,
  actionsLoadingThingChannelType: false,


  thingChannelTypeOptions:undefined,
  thingChannelTypeOptionForEdit: undefined,
  thingChannelTypeOptionsTotalCount: 0,
  listLoadingThingChannelTypeOption: false,
  actionsLoadingThingChannelTypeOption: false,


  thingChannelDefinitions:undefined,
  thingChannelDefinitionForEdit: undefined,
  thingChannelDefinitionsTotalCount: 0,
  listLoadingThingChannelDefinition: false,
  actionsLoadingThingChannelDefinition: false,

  
  deviceTypes: null,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const thingChannelsSlice = createSlice({
  name: "thingChannels",
  initialState: initialThingChannelsState,
  reducers: {
    
    catchErrorThingChannelType: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoadingThingChannelType = false;
      } else {
        state.actionsLoadingThingChannelType = false;
      }
    },
    startCallThingChannelType: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoadingThingChannelType = true;
      } else {
        state.actionsLoadingThingChannelType = true;
      }
    },
    catchErrorThingChannelTypeOption: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoadingThingChannelTypeOption = false;
      } else {
        state.actionsLoadingThingChannelTypeOption = false;
      }
    },
    startCallThingChannelTypeOption: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoadingThingChannelTypeOption = true;
      } else {
        state.actionsLoadingThingChannelTypeOption = true;
      }
    },
    catchErrorThingChannelDefinition: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoadingThingChannelDefinition = false;
      } else {
        state.actionsLoadingThingChannelDefinition = false;
      }
    },
    startCallThingChannelDefinition: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoadingThingChannelDefinition = true;
      } else {
        state.actionsLoadingThingChannelDefinition = true;
      }
    },


    // Get Thing Channel Type
    thingChannelTypeFetched: (state, action) => {
      state.actionsLoadingThingChannelType = false;
      state.thingChannelTypeForEdit = action.payload.thingChannelTypeForEdit;
      state.error = null;
    },
    // Thing Channel Type List
    thingChannelTypesFetched: (state, action) => {
      const { totalCount, data } = action.payload;
      state.listLoadingThingChannelType = false;
      state.error = null;
      state.thingChannelTypes = data;
      state.thingChannelTypesTotalCount = totalCount;
    },
    // Create ThingChannelType
    thingChannelTypeCreated: (state, action) => {
     
      state.actionsLoadingThingChannelType = false;
      state.error = null;
      state.thingChannelTypes.push(action.payload.data);
    },
    // Update Thing Channel Type
    thingChannelTypeUpdated: (state, action) => {
      state.error = null;
      state.actionsLoadingThingChannelType = false;
      state.thingChannelTypes = state.thingChannelTypes.map((entity) => {
        if (entity.id === action.payload.thingChannelType.id) {
          return action.payload.thingChannelType;
        }
        return entity;
      });
    },
    // Delete Thing Channel Type
    thingChannelTypeDeleted: (state, action) => {
      state.error = null;
      state.actionsLoadingThingChannelType = false;
      state.thingChannelTypes = state.thingChannelTypes.filter(
        (el) => el.id !== action.payload.id
      );
    },


    // Get Thing Channel Type Option
    thingChannelTypeOptionFetched: (state, action) => {
      state.actionsLoadingThingChannelTypeOption = false;
      state.thingChannelTypeOptionForEdit = action.payload.thingChannelTypeOptionForEdit;
      state.error = null;
    },
    // Thing Channel Type Option List
    thingChannelTypeOptionsFetched: (state, action) => {
      const { totalCount, data } = action.payload;
      state.listLoadingThingChannelTypeOption = false;
      state.error = null;
      state.thingChannelTypeOptions = data;
      state.thingChannelTypeOptionsTotalCount = totalCount;
    },
    // Create ThingChannelTypeOption
    thingChannelTypeOptionCreated: (state, action) => {
     
      state.actionsLoadingThingChannelTypeOption = false;
      state.error = null;
      state.thingChannelTypeOptions.push(action.payload.data);
    },
    // Update Thing Channel Type Option
    thingChannelTypeOptionUpdated: (state, action) => {
      state.error = null;
      state.actionsLoadingThingChannelTypeOption = false;
      state.thingChannelTypeOptions = state.thingChannelTypeOptions.map((entity) => {
        if (entity.id === action.payload.thingChannelTypeOption.id) {
          return action.payload.thingChannelTypeOption;
        }
        return entity;
      });
    },
    // Delete Thing Channel Type Option
    thingChannelTypeOptionDeleted: (state, action) => {
      state.error = null;
      state.actionsLoadingThingChannelTypeOption = false;
      state.thingChannelTypeOptions = state.thingChannelTypeOptions.filter(
        (el) => el.id !== action.payload.id
      );
    },


    // Get Thing Channel Definition
    thingChannelDefinitionFetched: (state, action) => {
      state.actionsLoadingThingChannelDefinition = false;
      state.thingChannelDefinitionForEdit = action.payload.thingChannelDefinitionForEdit;
      state.error = null;
    },
    // Thing ChannelDefinition List
    thingChannelDefinitionsFetched: (state, action) => {
      const { totalCount, data } = action.payload;
      state.listLoadingThingChannelDefinition = false;
      state.error = null;
      state.thingChannelDefinitions = data;
      state.thingChannelDefinitionsTotalCount = totalCount;
    },
    // Create ThingChannelDefinitionn
    thingChannelDefinitionCreated: (state, action) => {
      
      state.actionsLoadingThingChannelDefinition = false;
      state.error = null;
      state.thingChannelDefinitions.push(action.payload.data);
    },
    // Update Thing Channel Definition
    thingChannelDefinitionUpdated: (state, action) => {
      state.error = null;
      state.actionsLoadingThingChannelDefinition = false;
      state.thingChannelDefinitions = state.thingChannelDefinitions.map((entity) => {
        if (entity.id === action.payload.thingChannelDefinition.id) {
          return action.payload.thingChannelDefinition;
        }
        return entity;
      });
    },
    // Delete Thing Channel Definition
    thingChannelDefinitionnDeleted: (state, action) => {
      state.error = null;
      state.actionsLoadingThingChannelDefinition = false;
      state.thingChannelDefinitions = state.thingChannelDefinitions.filter(
        (el) => el.id !== action.payload.id
      );
    },

    
    


  },
});
